import { render, staticRenderFns } from "./disclosure_nav_item.vue?vue&type=template&id=6e957f1a&vue3"
import script from "./disclosure_nav_item.vue?vue&type=script&lang=js&vue3"
export * from "./disclosure_nav_item.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports